export function getNameInitials(value: string) {
  if (!value) return "-";
  return value
    .split(" ")
    .map((name) => name.charAt(0).toUpperCase())
    .join("");
}
